// extracted by css-extract-rspack-plugin
export default {"dockedPanelContent":"DockedCopilotChatPortal-module__dockedPanelContent__ZvKyx","contentPreviewDialog":"DockedCopilotChatPortal-module__contentPreviewDialog__kY6zr"};